import en from '../en/dialog'

const cz: typeof en = {
  my_selection: 'Můj výběr',
  books: 'Knihy',
  no_books: 'Žádné knihy',
  no_books_text: 'Ve vašem výběru nejsou žádné knihy.',
  illustrations: 'Ilustrace',
  no_illustrations: 'Žádné ilustrace',
  no_illustrations_text: 'Ve vašem výběru nejsou žádné ilustrace.',
  delete_all: 'Smazat vše',
  close: 'Zavřít',
  open_in_mirador: 'Otevřít v Miradoru',
}

export default cz
